import React, { Component } from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { withRouter } from "react-router-dom";

class MemberTable extends Component {

  constructor(props) {
      super(props)
      this.state = {
          data: this.props.data,
      }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data)
      this.setState({ data: this.props.data })
  }

  onRowClick = row => {
    if(this.props.onRowClick === "details")
      this.props.history.push(`/internal/admin/members/${row.objectId}`);
  }

  render() {
    const members = this.state.data;
    const hidden = this.props.hide ? this.props.hide : [];


    if(!(members != null && members.length > 0))
      return <p style={{color: "#000000"}}>Keine Mitglieder</p>

    let memberItems = []

    members.map((member, idx) =>
      memberItems.push({
        objectId: member.objectId,
        title: member.genderTitle,
        name: member.lastname + ", " + member.firstname,
        position: member.position,
      })
    )

    return (
      <div>
        <BootstrapTable data={ memberItems } borderless={true} options={{ onRowClick: this.onRowClick }} hover={true} pagination={false}>
          { !hidden.includes("title") &&
            <TableHeaderColumn dataField="title">Anrede</TableHeaderColumn> }
            <TableHeaderColumn dataField="name" isKey dataSort={true}>Name</TableHeaderColumn>
          { !hidden.includes("position") &&
            <TableHeaderColumn dataField="position" dataSort={true}>Position</TableHeaderColumn> }
        </BootstrapTable>
      </div>
    )
  }
}

export default withRouter(MemberTable)



// WEBPACK FOOTER //
// /src/components/Tables/MemberTable.js